import Turbo from "@hotwired/turbo";
import jfComponents from "./components/jf-components.js";
import sidescroll from "./components/sidescroll.js";
import swiperSlideshow from "./components/swiperSlideshow.js";
import SwiperThumbs from "./components/swiperThumbs.js";
import chipsFetch from "./components/chips-fetch.js";
import jfChronology from "./components/jf-chronology.js";
import chipsShop from "./components/chips-shop.js";
import chipsInview from "./components/chips-inview.js";
import jpgcover from "./components/jpgcover.js";
import imgRestrictions from "./components/img-restrictions.js";

class App {
	constructor(options) {
		this.defaults = {
			defaultK: false,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "App";
		// this.init();
		this.initTurbo();
	}

	init() {
		// this.headerFuncs();

		this.initChipsFetch();
		this.initUI();
		this.initCardsUI();
		this.initSwiperGalleries();
		this.readmoreUI();
		this.initSidescroll();
		this.initChronology();
		this.initShop();
		this.initCalendars();
		this.initInview();
		this.toggleNewsletter();
		this.initVideos();
		this.initRestrictImgs();
		// this.initBG();
	}
	initTurbo() {
		this.initCardsUI();
		// this.initSwiperGalleries();

		document.addEventListener("turbo:load", () => {
			this.init();
			this.closeModal();
		});

		// turbo disable cache
		// document.addEventListener("turbo:before-fetch-request", (event) => {
		// 	event.fetchOptions.headers["Cache-Control"] = "no-cache";
		// });

		document.addEventListener("turbo:before-visit", () => {
			document.querySelector("body").classList.add("turbo-loading");
		});

		document.addEventListener("turbo:before-render", (event) => {
			document.querySelector("body").classList.add("turbo-loading");
			if (event.target.hasAttribute("data-turbo-preview") === true) {
				return;
			}
		});

		document.addEventListener("turbo:before-cache", () => {
			document
				.querySelector("body")
				.classList.add("turbo-loading load-from-cache");
			// this.closeModal();
		});

		document.addEventListener("turbo:render", () => {
			window.scrollTo(0, 0);
			requestAnimationFrame(() => {
				document.body.classList.remove("modal-on");
				setTimeout(function () {
					document.body.classList.remove("turbo-loading");
				}, 600);
				// document.body.classList.remove("turbo-loading");
			});
		});
	}

	initChipsFetch() {
		// const $el = document.querySelectorAll(".fetch-button");
		// if ($el && $el.length) {
		// 	$el.forEach((el) => {
		// 		new chipsFetch({ $el: el });
		// 	});
		// }
		new chipsFetch();
	}
	initSidescroll() {
		if (document.querySelector(".nav-breadcrumb")) {
			if (
				!document.querySelector(".scroller-left") &&
				document.querySelector(".nav-breadcrumb")
			) {
				document
					.querySelector(".nav-breadcrumb")
					.insertAdjacentHTML(
						"beforeend",
						'<button class="button-scroller scroller-left" aria-label="Scroll left"><span>Scroll left</span></button><button class="button-scroller scroller-right" aria-label="Scroll right"><span>Scroll right</span></button>'
					);
			}

			const SidescrollEls = document.querySelectorAll(
				".nav-breadcrumb > ul"
			);
			if (SidescrollEls.length > 0) {
				SidescrollEls.forEach((el) => {
					const SidescrollEl = new sidescroll({ $el: el });
				});
			}
		}
	}

	initUI() {
		const appScope = this;
		const $el_Search = document.getElementById("s");
		if ($el_Search) {
			$el_Search.setAttribute("placeholder", "Search");
		}

		const $el = document.querySelectorAll(".menu-toggle");
		if (
			$el &&
			$el.length &&
			(($el.classList && !$el.classList.includes("ui-init")) ||
				!$el.classList)
		) {
			// Remove event listener
			// document.removeEventListener("keyup", appScope.handleKeyUpListener);

			// Add event listener
			document.addEventListener("keyup", (e) => {
				appScope.handleKeyUp(e);
			});

			$el.forEach((el) => {
				el.classList.add("ui-init");
				el.removeEventListener("click", appScope.handleMenuToggle);
				el.addEventListener("click", appScope.handleMenuToggle);
			});
		} else if ($el && $el.length) {
			console.log("Caught double bind attempt");
			el.removeEventListener("click", appScope.handleMenuToggle);
			el.addEventListener("click", appScope.handleMenuToggle);
		}

		const $elBackTop = document.querySelectorAll(".back-top");
		if ($elBackTop && $elBackTop.length) {
			$elBackTop.forEach((el) => {
				el.addEventListener("click", () => {
					document.querySelector("html,body").scrollTop = 0;
				});
			});
		}

		const $elClose = document.querySelectorAll(".menu-close");
		if ($elClose && $elClose.length) {
			$elClose.forEach((el) => {
				el.addEventListener("click", () => {
					document.body.classList.remove("menu-open");
				});
			});
		}

		const $filterModalToggle = document.querySelectorAll(".edit-filters");
		if ($filterModalToggle && $filterModalToggle.length) {
			$filterModalToggle.forEach((el) => {
				el.addEventListener("click", () => {
					if (
						document
							.querySelector("body")
							.classList.contains("modal-on")
					) {
						requestAnimationFrame(() => {
							document
								.querySelector("body")
								.classList.remove("modal-on");
						});
						if (document.querySelector(".modal")) {
							requestAnimationFrame(() => {
								document
									.querySelector(".modal")
									.classList.remove("modal-on");
							});
						}
					} else {
						document
							.querySelector("body")
							.classList.add("modal-on");
						if (window.innerWidth >= 1024) {
							document.querySelector(".modal-contents a").focus();
						}
						if (document.querySelector(".modal")) {
							document
								.querySelector(".modal")
								.classList.add("modal-on");
						}
					}
				});
			});
		}

		const $filterModalClose = document.querySelectorAll(".modal-close");
		if ($filterModalClose && $filterModalClose.length) {
			$filterModalClose.forEach((el) => {
				el.addEventListener("click", () => {
					this.closeModal();
				});
			});
		}

		const $modalScrollable = document.querySelectorAll(".modal-scrollable");
		if ($modalScrollable && $modalScrollable.length) {
			$modalScrollable.forEach((el) => {
				el.addEventListener("click", (e) => {
					const elLocal = e.target;
					if (
						!elLocal.classList.contains("modal-contents") &&
						!elLocal.closest(".modal-contents")
					) {
						this.closeModal();
					}
				});
			});
		}

		if (document.querySelector(".select-autochange")) {
			document.querySelectorAll(".select-autochange").forEach((el) => {
				el.addEventListener("change", () => {
					let newVal = el.value;
					if (newVal !== "") {
						window.location = newVal;
					}
				});
			});
		}

		// if .launch__spaces-modal exists, add event listener to open modal
		const $launchSpacesModal = document.querySelectorAll(
			".launch__spaces-modal"
		);
		if ($launchSpacesModal && $launchSpacesModal.length) {
			$launchSpacesModal.forEach((el) => {
				el.addEventListener("click", (e) => {
					e.preventDefault();
					console.log("Open spaces modal");

					document
						.querySelector(".modal--spaces")
						.classList.add("allow-ani");
					document
						.querySelector("body")
						.classList.add("modal__spaces--on");
				});
			});

			// if .modal__close--spaces-inline or .modal__close--spaces exist and are clicked, remove the modal-on class from body
			const $modalCloseSpacesInline = document.querySelectorAll(
				".modal__close--spaces-inline, .modal__close--spaces"
			);
			if ($modalCloseSpacesInline && $modalCloseSpacesInline.length) {
				$modalCloseSpacesInline.forEach((el) => {
					el.addEventListener("click", (e) => {
						e.preventDefault();
						document
							.querySelector("body")
							.classList.remove("modal__spaces--on");
					});
				});
			}
		}

		// if .shop__message exists, randomize background color
		// if (document.querySelector(".shop__message")) {
		// 	let colorChoices = [
		// 		"#7ACBD7",
		// 		"#A8A9AC",
		// 		"#B07A2F",
		// 		"#F3BB44",
		// 		"#44997D",
		// 		"#DF2B61",
		// 	];
		// 	let newVal =
		// 		colorChoices[Math.floor(Math.random() * colorChoices.length)];

		// 	document.documentElement.style.setProperty("--accent-bg", newVal);
		// }

		// document.addEventListener("click", (e) => {
		// 	if (e.metaKey) {
		// 		e.preventDefault();
		// 	}
		// });
	}

	handleMenuToggle() {
		if (document.body.classList.contains("menu-open")) {
			requestAnimationFrame(() => {
				document.body.classList.remove("menu-open");
			});
		} else {

			let colorChoices = [
				"#7ACBD7",
				"#A8A9AC",
				"#B07A2F",
				"#F3BB44",
				"#44997D",
				"#DF2B61",
			];
			let tempVal =
				document.documentElement.style.getPropertyValue("--accent-bg");
			let newVal =
				colorChoices[Math.floor(Math.random() * colorChoices.length)];
			if (tempVal !== "") {
				let tempIndex = colorChoices.indexOf(tempVal);
				if (tempIndex !== -1) {
					if (tempIndex === colorChoices.length - 1) {
						newVal = colorChoices[0];
					} else {
						newVal = colorChoices[tempIndex + 1];
					}
				}
			} else {
				newVal = colorChoices[0];
			}

			document.documentElement.style.setProperty("--accent-bg", newVal);


			
			requestAnimationFrame(() => {
				document.body.classList.add("menu-open");
			});
		}
	}

	handleKeyUp(e) {
		if (e.key === "Escape") {
			// console.log("EScape");
			// if (document.body.classList.contains("menu-open")) {
			// 	document.body.classList.remove("menu-open");
			// } else {
			// 	document.body.classList.add("menu-open");
			// }

			document.body.classList.remove("menu-open");
			this.closeModal();
		}
		if (e.key === "Tab") {
			if (document.body.classList.contains("menu-open")) {
				if (
					!document
						.querySelector(".nav-modal")
						.contains(document.activeElement)
				) {
					// document.querySelector(".menu-close").focus();
					document.body.classList.remove("menu-open");
					this.closeModal();
				}
			}
		}
	}

	closeModal() {
		document.querySelector("body").classList.remove("modal-on");
		if (document.querySelector(".modal")) {
			document.querySelector(".modal").classList.remove("modal-on");
		}
	}

	initCardsUI() {
		const $el = document.querySelectorAll(".card__landing");
		if ($el && $el.length) {
			$el.forEach((el) => {
				if (!el.querySelector(".cal-modal")) {
					el.addEventListener("click", () => {
						if (!el.closest("a")) {
							const link = el.querySelector("a");
							if (link) {
								link.click();
							}
						}
					});
				}
			});
		}
	}

	initCalendars() {
		const $el = document.querySelectorAll(".cal-modal");
		if ($el && $el.length) {
			$el.forEach((el) => {
				el.addEventListener("click", (e) => {
					e.preventDefault();

					const linkTarget = el.getAttribute("href");
					const modal = document.querySelector(".modal-cal");
					if (!modal) {
						// create modal
						const modal = document.createElement("div");
						modal.classList.add("modal-cal");
						modal.innerHTML = `<div class="modal-contents"></div>`;
						document.querySelector("body").appendChild(modal);
					}

					// append iframe to .modal-cal .modal-contents
					const iframe = document.createElement("iframe");
					iframe.setAttribute("frameborder", "0");
					iframe.setAttribute("src", linkTarget);
					document
						.querySelector(".modal-cal .modal-contents")
						.appendChild(iframe);

					document.querySelector("body").classList.add("modal-on");
					document
						.querySelector(".modal-cal")
						.classList.add("modal-on");

					// document
					// 	.querySelector(".modal-cal .modal-cal-close")
					// 	.addEventListener("click", (e) => {
					// 		e.preventDefault();
					// 		this.closeCalModal();
					// 	});
				});
			});
		}

		window.document.addEventListener(
			"closeModalEvt",
			(e) => {
				if (e.detail.modalEvent === "close") {
					clearTimeout(this.refreshTimer);
					document.querySelector("body").classList.remove("modal-on");
					if (document.querySelector(".modal-cal")) {
						document
							.querySelector(".modal-cal")
							.classList.remove("modal-on");
						if (document.querySelector(".modal-cal iframe")) {
							document
								.querySelector(".modal-cal iframe")
								.remove();
						}
					}
				}
			},
			false
		);

		const calCloseBtns = document.querySelectorAll(".modal-cal-close");
		if (calCloseBtns && calCloseBtns.length) {
			calCloseBtns.forEach((el) => {
				el.addEventListener("click", (e) => {
					e.preventDefault();
					this.closeCalModal();
				});
			});
		}
	}

	closeCalModal() {
		var modalCloseData = { modalEvent: "close" };
		var event = new CustomEvent("closeModalEvt", {
			detail: modalCloseData,
		});
		window.parent.document.dispatchEvent(event);

		this.refreshTimer = setTimeout(() => {
			if (document.querySelector(".modal-cal-close")) {
				window.location =
					document.querySelector(".modal-cal-close").href;
			}
		}, 1000);

		document.querySelector("body").classList.remove("modal-on");
		if (document.querySelector(".modal-cal")) {
			document.querySelector(".modal-cal").classList.remove("modal-on");
			document.querySelector(".modal-cal iframe").remove();
		}
	}

	initSwiperGalleries() {
		const swiperEls = document.querySelectorAll(".swiper");
		if (swiperEls && swiperEls.length > 0) {
			swiperEls.forEach((el) => {
				const swiper = new swiperSlideshow({ $el: el });
			});
		}
	}
	initRestrictImgs() {
		const imgRestrictEls = new imgRestrictions();
	}

	initInview() {
		const ivEls = document.querySelectorAll(
			".iv,.card__landing,.card,.row-flex"
		);
		if (ivEls && ivEls.length > 0) {
			ivEls.forEach((el) => {
				const ivEl = new chipsInview({ $el: el });
			});
		}
	}

	initVideos() {
		const jpgCoverEls = document.querySelectorAll(".jpg-cover");
		if (jpgCoverEls && jpgCoverEls.length > 0) {
			jpgCoverEls.forEach((el) => {
				const jpgCoverEl = new jpgcover({ $el: el });
			});
		}

		const pauseBtns = document.querySelectorAll(".button-pause");
		if (pauseBtns && pauseBtns.length > 0) {
			pauseBtns.forEach((el) => {
				el.addEventListener("click", () => {
					const scopeEl = el;
					scopeEl
						.closest(".videobg-wrap")
						.classList.add("vid-paused");
					const videoEl = scopeEl
						.closest(".videobg-wrap")
						.querySelector("iframe");
					videoEl.contentWindow.postMessage(
						'{"method":"pause"}',
						"https://player.vimeo.com"
					);
				});
			});
		}

		const playBtns = document.querySelectorAll(".button-play");
		if (playBtns && playBtns.length > 0) {
			playBtns.forEach((el) => {
				el.addEventListener("click", () => {
					const scopeEl = el;
					scopeEl
						.closest(".videobg-wrap")
						.classList.remove("vid-paused");
					const videoEl = scopeEl
						.closest(".videobg-wrap")
						.querySelector("iframe");
					videoEl.contentWindow.postMessage(
						'{"method":"play"}',
						"https://player.vimeo.com"
					);
				});
			});
		}

		const infoBtns = document.querySelectorAll(".button-info-wrap button");
		if (infoBtns && infoBtns.length > 0) {
			infoBtns.forEach((el) => {
				el.addEventListener("click", () => {
					const scopeEl = el;
					scopeEl
						.closest(".videobg-wrap")
						.classList.toggle("vid-info-on");
				});
			});
		}
	}

	toggleNewsletter() {
		// var bboxInit2 = bboxInit2 || [];
		// bboxInit2.push(function () {
		// 	bboxApi.showForm("c6f47a7b-3ee8-4c20-9a4e-b44f37c0782a");
		// });

		const $el = document.querySelectorAll(".newsletter-link");
		if ($el && $el.length) {
			$el.forEach((el) => {
				el.addEventListener("click", (e) => {
					e.preventDefault();
					el.closest(".form-parent").classList.add("form-on");
					// document
					// 	.querySelector("body")
					// 	.classList.add("smooth-scroll");
					// setTimeout(() => {
					// el.closest(".form-parent")
					// 	.querySelector("input")
					// 	.focus();
					// document.querySelector("html,body").scrollTop =
					// 	document.querySelector("html,body").scrollTop + 150;
					// }, 200);
					// }, 300);
				});
			});
		}
	}

	readmoreUI() {
		const $el = document.querySelectorAll(".readmore-toggle");
		if ($el && $el.length) {
			$el.forEach((el) => {
				el.addEventListener("click", () => {
					el.closest(".rte")
						.querySelector(".more-wrap")
						.classList.add("more-vis");
					el.closest(".rte")
						.querySelector(".readmore-content")
						.classList.add("vis");
					el.remove();
				});
			});
		}
	}

	initChronology() {
		// find any .chron-wrap.grid-layout elements without a .chron-init class
		const chronEls = document.querySelectorAll(
			".chron-wrap.grid-layout:not(.chron-init)"
		);
		if (chronEls && chronEls.length > 0) {
			chronEls.forEach((el) => {
				el.classList.add("chron-init");
				const chron = new jfChronology({ $el: el });
			});
		}
	}

	initShop() {
		const shopInit = new chipsShop();
	}
}

const app = new App();
